import { normalizeFinanceReportAttrs } from "./finance-report-contract";

export const ANALYTICAL_REPORT_NODE = "financeAnalyticalReport";
export const ANALYTICAL_REPORT_DEFAULTS = { title: "Аналитический доклад", period: "latest" } as const;

export function normalizeAnalyticalReportAttrs(value: unknown) {
  const attrs = value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
  const title = typeof attrs.title === "string" && attrs.title.replace(/[\u0000-\u001F\u007F]/g, " ").trim() ? attrs.title : ANALYTICAL_REPORT_DEFAULTS.title;
  return normalizeFinanceReportAttrs({ ...attrs, title });
}
